<template>
    <div>

        <div class="text-2xl text-grey-darkest mb-4">All User Quotas</div>
        <div class="text-teal hover:text-teal-dark font-base text-sm mb-4 flex justify-between">
            <div @click="goBack" class="flex cursor-pointer">
                <span class="material-icons">chevron_left</span>
                <span>Back</span>
            </div>
        </div>

        <div class="col-3 offset-9">

            <datepicker
                v-model="selectedYear"
                :format="datePickerFormat"
                :value="selectedYear"
                minimum-view="year"
                name="datepicker"
                calendar-class="datePickerCalendarCss"
                id="input-id"
                input-class="cursor-pointer rounded text-sm focus:outline-none border-1 form-control bg-white"
                popover-align="center">
            </datepicker>

        </div>
        <div id="quotaModal" class="modal fade" role="dialog">
            <div class="modal-dialog" style="max-width: 40% !important;">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">{{ current_quota ? 'Edit Quota' : 'New Quota' }}</h4>
                        <button type="button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <b-button variant="primary" :variant="user_tab ? 'primary' : 'outline-primary'"
                                  @click="(user_tab = true, office_tab = false)">User Quota
                        </b-button>
                        <b-button :variant="office_tab ? 'primary' : 'outline-primary'"
                                  @click="(user_tab = false, office_tab = true),updateOfficeQuotas">Quota Breakdown
                        </b-button>
                        <hr>
                        <form @keydown="form.errors.clear($event.target.name)">

                            <div v-show="user_tab" id="user">
                                <div class="mb-2 mt-2">
                                    <label class="text-sm text-grey-darkest -mb-0"
                                           :class="{'text-red': form.errors.has('date')}">Month / Year</label>
                                    <datepicker v-model="form.date" :minimumView="'month'" :maximumView="'month'" :use-utc="true"
                                                format="MM / yyyy" @input="form.errors.clear('date')"
                                                :input-class="{'border-red' : form.errors.has('date'), 'cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 form-control' : true}"></datepicker>
                                    <div class="text-red text-xs" v-if="form.errors.has('date')">{{
                                            form.errors.get('date')
                                        }}
                                    </div>
                                </div>
                                <hr>
                                <div>
                                    <label class="text-sm text-grey-darkest -mb-0" for="proposal_count"
                                           :class="{'text-red': form.errors.has('proposal_count')}">Bid Count</label>
                                    <input v-model="form.proposal_count" type="number" name="proposal_count"
                                           id="proposal_count"
                                           @wheel="$event.target.blur()"
                                           class="rounded w-full p-1 text-grey-darkest text-sm form-control"
                                           :class="{'border-red': form.errors.has('proposal_count')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('proposal_count')">{{
                                            form.errors.get('proposal_count')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <label class="text-sm text-grey-darkest -mb-0" for="proposal_volume"
                                           :class="{'text-red': form.errors.has('proposal_volume')}">Bid Volume
                                        ($)</label>
                                    <currency-input
                                        id="proposal_volume"
                                        v-model="form.proposal_volume"
                                        locale="us"
                                        :currency="null"
                                        class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 form-control"
                                        :class="{'border-red': form.errors.has('proposal_volume')}">
                                    </currency-input>
                                    <div class="text-red text-xs" v-if="form.errors.has('proposal_volume')">{{
                                            form.errors.get('proposal_volume')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <label class="text-sm text-grey-darkest -mb-0" for="proposal_gross_margin"
                                           :class="{'text-red': form.errors.has('proposal_gross_margin')}">Bid Gross
                                        Margin
                                        ($)</label>
                                    <currency-input
                                        id="proposal_gross_margin"
                                        v-model="form.proposal_gross_margin"
                                        locale="us"
                                        :currency="null"
                                        class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 form-control"
                                        :class="{'border-red': form.errors.has('proposal_gross_margin')}">
                                    </currency-input>
                                    <div class="text-red text-xs" v-if="form.errors.has('proposal_gross_margin')">{{
                                            form.errors.get('proposal_gross_margin')
                                        }}
                                    </div>
                                </div>
                                <hr>
                                <div>
                                    <label class="text-sm text-grey-darkest -mb-0" for="contract_count"
                                           :class="{'text-red': form.errors.has('contract_count')}">Contract
                                        Count</label>
                                    <input v-model="form.contract_count" type="number" name="contract_count"
                                           id="contract_count"
                                           @wheel="$event.target.blur()"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 form-control"
                                           :class="{'border-red': form.errors.has('contract_count')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('contract_count')">{{
                                            form.errors.get('contract_count')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <label class="text-sm text-grey-darkest -mb-0" for="contract_volume"
                                           :class="{'text-red': form.errors.has('contract_volume')}">Contract Volume
                                        ($)</label>
                                    <currency-input
                                        id="contract_volume"
                                        v-model="form.contract_volume"
                                        locale="us"
                                        :currency="null"
                                        class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 form-control"
                                        :class="{'border-red': form.errors.has('contract_volume')}">
                                    </currency-input>
                                    <div class="text-red text-xs" v-if="form.errors.has('contract_volume')">{{
                                            form.errors.get('contract_volume')
                                        }}
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <label class="text-sm text-grey-darkest -mb-0" for="contract_gross_margin"
                                           :class="{'text-red': form.errors.has('contract_gross_margin')}">Contract
                                        Gross Margin
                                        ($)</label>
                                    <currency-input
                                        id="contract_gross_margin"
                                        v-model="form.contract_gross_margin"
                                        locale="us"
                                        :currency="null"
                                        class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 form-control"
                                        :class="{'border-red': form.errors.has('contract_gross_margin')}">
                                    </currency-input>
                                    <div class="text-red text-xs" v-if="form.errors.has('contract_gross_margin')">{{
                                            form.errors.get('contract_gross_margin')
                                        }}
                                    </div>
                                </div>
                                <hr>
                                <div>
                                    <label class="text-sm text-grey-darkest -mb-0" for="sales_behavior_hours"
                                           :class="{'text-red': form.errors.has('sales_behavior_hours')}">Sales Behavior
                                        (Hrs)</label>
                                    <input v-model="form.sales_behavior_hours" type="number" name="sales_behavior_hours"
                                           id="sales_behavior_hours"
                                           @wheel="$event.target.blur()"
                                           class="rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 form-control"
                                           :class="{'border-red': form.errors.has('sales_behavior_hours')}">
                                    <div class="text-red text-xs" v-if="form.errors.has('sales_behavior_hours')">{{
                                            form.errors.get('sales_behavior_hours')
                                        }}
                                    </div>
                                </div>
                            </div>

                            <div v-show="office_tab" id="office">
                                <div class="mb-2">
                                    <label class="text-sm text-grey-darkest" for="office_id">Select Office</label>
                                    <select name="office_id" id="office_id" v-model="form.office_id"
                                            class="text-grey-darkest text-sm form-control"
                                            :class="{'text-red': customErrors.office_id}"
                                            @change="customErrors.office_id=null, (form.office_id = checkOffice($event))">
                                        <option selected>Select Office</option>
                                        <option v-for="office in office_options" :value="office.id">{{ office.code }}</option>
                                    </select>

                                    <div class="text-red text-xs" v-if="customErrors.office_id">
                                        {{ customErrors.office_id }}
                                    </div>
                                </div>

                                <div class="mb-2 w-2/5">
                                    <label class="text-sm text-grey-darkest">Quota Percentage (%)
                                        <i class="fa fa-info-circle ml-2" aria-hidden="true"
                                           title="% entered will be calculated on the bid quota % & contract quota % set for the user under the user quota tab"></i>
                                    </label>
                                    <input type="number" name="office_quota_percentage" id="office_quota_percentage"
                                           min="0" max="100"
                                           :disabled="office_selected_percentage"
                                           v-model="form.office_percentage" placeholder="%"
                                           @wheel="$event.target.blur()"
                                           :class="{'text-red': customErrors.office_quota_percentage}"
                                           class="text-grey-darkest text-sm form-control"
                                           @input="(customErrors.office_quota_percentage = calculateOfficePercentage($event))"
                                           @keydown="customErrors.office_quota_percentage=null"/>

                                    <div class="text-red text-xs" v-if="customErrors.office_quota_percentage">
                                        {{ customErrors.office_quota_percentage }}
                                    </div>
                                </div>

                                <div class="mt-2 mb-2">
                                    <span v-if="selected_contract_types.length === 0" class="text-primary"
                                          style="cursor: pointer;" @click="addContractQuotaDiv('false')"><u>Set Contract Type % for the location</u></span>
                                </div>
                                <div class="ml-8" v-if="selected_contract_types.length > 0">
                                        <span v-for="(item,index) in selected_contract_types">
                                        <div class="mb-2">
                                            <label class="text-sm text-grey-darkest" for="contract_type_id">Select Contract Type</label>
                                            <div class="d-flex w-full">
                                                <span class="" style="width: 90%;">
                                                <select name="contract_type_id" id="contract_type_id"
                                                        @change="(item.contract_type_id = checkContractType($event,item,index))"
                                                        v-model="item.contract_type_id"
                                                        class="text-grey-darkest text-sm form-control"
                                                        style="width: 100% !important; margin-right: 5px">
                                                <option selected>Select Contract Type</option>
                                                <option v-for="contractType in contractTypes" :value="contractType.id">{{
                                                        contractType.code
                                                    }}</option>
                                            </select>
                                            </span>
                                                <span class="">
                                                <b-button variant="danger" class="btn-sm ml-2"
                                                          @click.prevent="deleteContractTypeQuota(item,index)">
                                                <i class="fa fa-trash" aria-hidden="true"></i>
                                            </b-button>
                                            </span>
                                            </div>

                                            <div class="text-red text-xs" v-if="item.contract_type_id_error">
                                                {{ item.contract_type_id_error }}
                                            </div>
                                        </div>

                                        <div class="mb-2">
                                            <label class="text-sm text-grey-darkest"
                                                   for="contract_type_percentage">Quota Percentage (%)
                                                <i class="fa fa-info-circle ml-2" aria-hidden="true"
                                                   title="% entered will be calculated on the office quota % entered above"></i>
                                            </label>
                                            <input type="number" name="contract_type_percentage"
                                                   min="0" max="100"
                                                   id="contract_type_percentage"
                                                   @wheel="$event.target.blur()"
                                                   @input="(item.contract_type_percentage_error = calculateContractTypePercentage($event,item,index))"
                                                   v-model="item.percentage"
                                                   :class="{'text-red': item.contract_type_percentage_error}"
                                                   class="text-grey-darkest text-sm form-control w-2/5"/>

                                            <div class="text-red text-xs" v-if="item.contract_type_percentage_error">
                                                {{ item.contract_type_percentage_error }}
                                            </div>
                                        </div>
                                        </span>
                                </div>


                                <div class="ml-8 mt-2 mb-2">
                                    <span
                                        v-if="selected_contract_types.length > 0 && selected_contract_types.length !== contractTypes.length"
                                        class="text-primary" style="cursor: pointer;"
                                        @click="addContractQuotaDiv('true')"><u>Set % for another Contract Type</u></span>
                                </div>
                                <div class="mb-2">
                                    <b-button variant="primary" class="pull-right" @click.prevent="addOfficeQuota">Add
                                    </b-button>

                                </div>

                                <hr class="mt-12">
                                <div class="mt-2 table-responsive">
                                    <table class="text-black table table-striped">
                                        <thead>
                                        <th class="whitespace-no-wrap">OFFICE</th>
                                        <th class="whitespace-no-wrap">BID VOL</th>
                                        <th class="whitespace-no-wrap">CONTRACT VOL</th>
                                        <template v-for="contractType in contractTypes">
                                            <th class="whitespace-no-wrap">
                                                BID VOL ({{ contractType.code }})
                                            </th>
                                            <th class="whitespace-no-wrap">
                                                CONTRACT VOL ({{ contractType.code }})
                                            </th>

                                        </template>
                                        <th class="whitespace-no-wrap">SALES BEHAVIOR HOURS</th>
                                        <th class="whitespace-no-wrap">Action</th>
                                        </thead>
                                        <tbody>
                                        <tr v-for="item in form.office_quotas">
                                            <td :id="item.office_id" class="whitespace-no-wrap">{{
                                                    item.office_name
                                                }}
                                            </td>
                                            <td class="whitespace-no-wrap">
                                                {{ item.proposal_volume + '(' + item.percentage + '%)' }}
                                            </td>
                                            <td class="whitespace-no-wrap">
                                                {{ item.contract_volume + '(' + item.percentage + '%)' }}
                                            </td>
                                            <template v-for="contractType in contractTypes"
                                                      class="whitespace-no-wrap text-center">
                                                <template v-if="item.office_contract_type_quotas &&
                                                           item.office_contract_type_quotas.length > 0 &&
                                                           item.office_contract_type_quotas.find(x => x.contract_type_id === contractType.id)">

                                                    <template v-for="selectedContractType in item.office_contract_type_quotas">
                                                        <template v-if="selectedContractType.contract_type_id === contractType.id">
                                                            <td>
                                                                {{setBidVolume(item.proposal_volume, selectedContractType) }}
                                                            </td>
                                                            <td>
                                                                {{setContractVolume(item.contract_volume, selectedContractType) }}
                                                            </td>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template
                                                    v-if="!item.office_contract_type_quotas ||
                                                        item.office_contract_type_quotas.length === 0 ||
                                                        !item.office_contract_type_quotas.find(x => x.contract_type_id === contractType.id)">
                                                    <td>-</td>
                                                    <td>-</td>
                                                </template>
                                            </template>

                                            <td class="whitespace-no-wrap">{{ item.sales_behavior_hours }}</td>
                                            <td class="whitespace-no-wrap">
                                                <button @click.prevent="removeOfficeQuota(item.office_id)"
                                                        class="border-2 pull-right border-red focus:outline-none font-semibold
                                                           hover:bg-red
                                                           hover:no-underline
                                                           hover:text-white
                                                           material-icons p-1
                                                           rounded-full
                                                           text-base
                                                           text-red">
                                                    remove
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>

                                </div>

                            </div>
                        </form>


                    </div>
                    <div class="modal-footer"  style="justify-content: space-between !important;">
                        <label for=""><input type="checkbox" v-model="remainderStatus">&nbsp;&nbsp;Apply to remainder of year</label>
                        <b-button variant="primary" @click.prevent="saved" :disabled="!issave">
                            Save
                            <i v-show="!issave" class="fa fa-1x fa-spinner fa-spin text-teal "></i>
                        </b-button>
                    </div>
                </div>

            </div>
        </div>

        <div v-if="allMember.length > 0" class="text-grey-darkest bg-white rounded mb-6 mt-2" style="max-height:700px;overflow-y: scroll;">
            <div>
                <table class="text-left w-full border-collapse" style="table-layout: fixed;">
                    <thead>
                    <tr>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" style="width:45px;"><input type="checkbox" v-model="selectAll"></th>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" @click='sort("name")' style="width:220px;">
                            User <i :class="sortOrder == 1 ? 'fa fa-xs ml-2 fa-chevron-up' : 'fa fa-xs ml-2 fa-chevron-down'"></i>
                        </th>
                        <th v-for="index in monthArray" :key="index" class="py-2 bg-grey-lightest text-center font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" style="width:60px;">
                            {{getMonthName(index)+' '+currentYear}}
                        </th>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-center text-grey-darkest border-b border-grey-light" style="width:60px;">
                            Net Total
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="hover:bg-grey-lighter cursor-pointer" v-for="member in sortedList">
                        <td class="py-2 border-b border-grey-light text-xs"><input type="checkbox" :value="member.id" v-model="selectedMember"></td>
                        <td class="py-2 border-b border-grey-light text-xs" style="min-width:250px;max-width:250px;">
                            <div style="display:flex;">
                                <div>
                                    <img :src="member.photo_url ? member.photo_url : 'https://www.gravatar.com/avatar/2f9db33177a44084e0eab323a049121e.jpg?s=200&amp;d=mm'" alt="User Photo" class="dropdown-toggle-image spark-nav-profile-photo">
                                </div>
                                <div style="word-wrap: break-word;">
                                    {{ member.name }}<br>{{ member.email }}
                                </div>
                            </div>
                        </td>
                        <td v-for="index in monthArray" :key="index" class="py-2 text-center border-b border-grey-light text-xs" style="width:60px;padding-left: 12px;">
                            <button @click.stop="editQuota(member, index)" class="text-info" style="width:60px;padding-left: 12px;"><div class="scrollbar">{{member.goal_label[index-1]}}</div></button>
                        </td>
                        <td class="py-2 border-b text-center border-grey-light text-xs" style="width:60px;padding-left: 12px;">
                            <div class="scrollbar">${{member.totalQuota}}</div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="text-grey-darkest bg-white rounded mb-6 mt-2" style="overflow-y: scroll;border:2px solid black;">
            <div>
                <table class="text-left w-full border-collapse" style="table-layout: fixed;">
                    <thead>
                    <tr>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" style="width:45px;"><input type="checkbox" style="visibility:hidden;"></th>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" style="width:220px;">
                            User Overall
                        </th>
                        <th v-for="index in monthArray" :key="index" class="py-2 bg-grey-lightest text-center font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" style="width:60px;">
                            Total
                        </th>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-center text-grey-darkest border-b border-grey-light" style="width:60px;">
                            Net Total
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="hover:bg-grey-lighter cursor-pointer">
                        <td class="py-2 border-b border-grey-light text-xs"><input type="checkbox" style="visibility:hidden;"></td>
                        <td class="py-2 border-b border-grey-light text-xs" style="min-width:250px;max-width:250px;">
                            {{allMemberOverall.code}}
                        </td>
                        <td v-for="index in monthArray" :key="index" class="py-2 text-center border-b border-grey-light text-xs" style="width:60px;padding-left: 12px;">
                            <div class="scrollbar">${{(allMemberOverall && allMemberOverall.contractAmount && allMemberOverall.contractAmount.length > 0) ? allMemberOverall.contractAmount[index-1] : ''}}</div>
                        </td>
                        <td class="py-2 border-b text-center border-grey-light text-xs" style="width:60px;padding-left: 12px;">
                            <div class="scrollbar">${{allMemberOverall.totalQuota}}</div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="text-grey-darkest bg-white rounded mb-6 mt-2" style="max-height:500px;overflow-y: scroll;">
            <div>
                <table class="text-left w-full border-collapse" style="table-layout: fixed;">
                    <thead>
                    <tr>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" style="width:45px;"><input type="checkbox" style="visibility:hidden;"></th>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" style="width:220px;">
                            Office
                        </th>
                        <th v-for="index in monthArray" :key="index" class="py-2 bg-grey-lightest text-center font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" style="width:60px;">
                            Total
                        </th>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-center text-grey-darkest border-b border-grey-light" style="width:60px;">
                            Net Total
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="hover:bg-grey-lighter cursor-pointer" v-for="(office, index) in officeQuotaList" :key="index">
                        <td class="py-2 border-b border-grey-light text-xs"><input type="checkbox" style="visibility:hidden;"></td>
                        <td class="py-2 border-b border-grey-light text-xs" style="min-width:250px;max-width:250px;">
                            {{office.code}}
                        </td>
                        <td v-for="index in monthArray" :key="index" class="py-2 text-center border-b border-grey-light text-xs" style="width:60px;padding-left: 12px;">
                            <div class="scrollbar">${{office.contractAmount[index-1]}}</div>
                        </td>
                        <td class="py-2 border-b text-center border-grey-light text-xs" style="width:60px;padding-left: 12px;">
                            <div class="scrollbar">${{office.totalQuota}}</div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="text-grey-darkest bg-white rounded mb-6 mt-2" style="overflow-y: scroll;border:2px solid black;">
            <div>
                <table class="text-left w-full border-collapse" style="table-layout: fixed;">
                    <thead>
                    <tr>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" style="width:45px;"><input type="checkbox" style="visibility:hidden;"></th>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" style="width:220px;">
                            Office Overall
                        </th>
                        <th v-for="index in monthArray" :key="index" class="py-2 bg-grey-lightest text-center font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" style="width:60px;">
                            Total
                        </th>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-center text-grey-darkest border-b border-grey-light" style="width:60px;">
                            Net Total
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="hover:bg-grey-lighter cursor-pointer">
                        <td class="py-2 border-b border-grey-light text-xs"><input type="checkbox" style="visibility:hidden;"></td>
                        <td class="py-2 border-b border-grey-light text-xs" style="min-width:250px;max-width:250px;">
                            {{allOfficeOverall.code}}
                        </td>
                        <td v-for="index in monthArray" :key="index" class="py-2 text-center border-b border-grey-light text-xs" style="width:60px;padding-left: 12px;">
                            <div class="scrollbar">${{(allOfficeOverall && allOfficeOverall.contractAmount && allOfficeOverall.contractAmount.length > 0) ? allOfficeOverall.contractAmount[index-1] : ''}}</div>
                        </td>
                        <td class="py-2 border-b text-center border-grey-light text-xs" style="width:60px;padding-left: 12px;">
                            <div class="scrollbar">${{allOfficeOverall.totalQuota}}</div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="text-grey-darkest bg-white rounded mb-6 mt-2" style="max-height:500px;overflow-y: scroll;">
            <div>
                <table class="text-left w-full border-collapse" style="table-layout: fixed;">
                    <thead>
                    <tr>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" style="width:45px;"><input type="checkbox" style="visibility:hidden;"></th>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" style="width:220px;">
                            Contract Type
                        </th>
                        <th v-for="index in monthArray" :key="index" class="py-2 bg-grey-lightest text-center font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" style="width:60px;">
                            Total
                        </th>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-center text-grey-darkest border-b border-grey-light" style="width:60px;">
                            Net Total
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="hover:bg-grey-lighter cursor-pointer" v-for="(type, index) in contractTypeQuotaList" :key="index">
                        <td class="py-2 border-b border-grey-light text-xs"><input type="checkbox" style="visibility:hidden;"></td>
                        <td class="py-2 border-b border-grey-light text-xs" style="min-width:250px;max-width:250px;">
                            {{type.code}}
                        </td>
                        <td v-for="index in monthArray" :key="index" class="py-2 text-center border-b border-grey-light text-xs" style="width:60px;padding-left: 12px;">
                            <div class="scrollbar">${{type.contractAmount[index-1]}}</div>
                        </td>
                        <td class="py-2 border-b text-center border-grey-light text-xs" style="width:60px;padding-left: 12px;">
                            <div class="scrollbar">${{type.totalQuota}}</div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="text-grey-darkest bg-white rounded mb-6 mt-2" style="overflow-y: scroll;border:2px solid black;">
            <div>
                <table class="text-left w-full border-collapse" style="table-layout: fixed;">
                    <thead>
                    <tr>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" style="width:45px;"><input type="checkbox" style="visibility:hidden;"></th>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" style="width:220px;">
                            Contract Type Overall
                        </th>
                        <th v-for="index in monthArray" :key="index" class="py-2 bg-grey-lightest text-center font-bold uppercase text-xs text-grey-darkest border-b border-grey-light" style="width:60px;">
                            Total
                        </th>
                        <th class="py-2 bg-grey-lightest font-bold uppercase text-xs text-center text-grey-darkest border-b border-grey-light" style="width:60px;">
                            Net Total
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="hover:bg-grey-lighter cursor-pointer">
                        <td class="py-2 border-b border-grey-light text-xs"><input type="checkbox" style="visibility:hidden;"></td>
                        <td class="py-2 border-b border-grey-light text-xs" style="min-width:250px;max-width:250px;">
                            {{allContractTypeOverall.code}}
                        </td>
                        <td v-for="index in monthArray" :key="index" class="py-2 text-center border-b border-grey-light text-xs" style="width:60px;padding-left: 12px;">
                            <div class="scrollbar">${{(allContractTypeOverall && allContractTypeOverall.contractAmount && allContractTypeOverall.contractAmount.length > 0) ? allContractTypeOverall.contractAmount[index-1] : ''}}</div>
                        </td>
                        <td class="py-2 border-b text-center border-grey-light text-xs" style="width:60px;padding-left: 12px;">
                            <div class="scrollbar">${{allContractTypeOverall.totalQuota}}</div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="proposal-overlay">
            <img src="https://app.followupcrm.com/images/proposal-loader.gif" />
        </div>
    </div>
</template>

<script>

    import Form from "../../../utils/form";
    import Datepicker from 'vuejs-datepicker';

    export default {

        props:['offices', 'contractTypes', 'currentTeamId', 'actionTeamId'],

        components: {Datepicker},

        data() {
            return {
                editing: false,
                current_quota: null,
                form: new Form({
                    date: null,
                    proposal_volume: null,
                    contract_volume: null,
                    proposal_gross_margin: null,
                    contract_gross_margin: null,
                    proposal_count: null,
                    contract_count: null,
                    sales_behavior_hours: '',
                    office_quotas: [],
                    office_id:null,
                    office_percentage:null,
                    contract_type_quotas: [],
                    contract_type_id:null,
                    contract_type_percentage:null,
                    currentSelectedYear: new Date().getFullYear(),
                }),
                customErrors: {
                    'office_quota_percentage': null,
                    'office_id': null,
                    'contract_type_percentage': null,
                    'contract_type_id': null,
                },
                monthArray: [1,2,3,4,5,6,7,8,9,10,11,12],
                currentYear: new Date().getFullYear(),
                shortMonth:null,
                date:null,
                currentMember:null,
                selectedMember:[],
                remainderStatus: false,
                datePickerFormat: 'yyyy',
                selectedYear: new Date(),
                setGoalLabel: '',
                allMember:[],
                officeQuotaList: [],
                contractTypeQuotaList: [],
                sortBy: "name",
                sortOrder: 1,
                allMemberOverall:{},
                allOfficeOverall:{},
                allContractTypeOverall:{},
                issave: true,
                user_tab: true,
                office_tab: false,
                selected_contract_types: [],
                office_options: [],
                office_selected_percentage: false,
                contract_type_percentage_value: 0
            }
        },

        mounted() {
            let self = this;
            $("#quotaModal").on('hidden.bs.modal', function () {
                self.form.reset();
                self.customErrors = {
                    'office_quota_percentage': null,
                    'office_id': null,
                    'contract_type_percentage': null,
                    'contract_type_id': null,
                };
                self.contract_type_percentage_value = 0;
                self.selected_contract_types = [];
                self.current_quota = null;
                self.editing = false;
            });

            self.getQuotaData();
        },
        created() {
            this.setOfficeOptions();
        },

        watch: {

            selectedYear(val){

                this.form.currentSelectedYear = new Date(val).getFullYear();
                this.currentYear = new Date(val).getFullYear();
                this.getQuotaData();
            }
        },

        computed: {

            selectAll: {

                get: function () {
                    return this.allMember ? this.selectedMember.length == this.allMember.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.allMember.forEach(function (user) {
                            selected.push(user.id);
                        });
                    }

                    this.selectedMember = selected;
                }
            },

            sortedList() {
                return [...this.allMember]
                    .map(i => ({...i, name:i.name}))
                    .sort((a,b) => {
                    if (a[this.sortBy] >= b[this.sortBy]) {
                        return this.sortOrder
                    }
                    return -this.sortOrder
                })
            }
        },

        methods: {
            setOfficeOptions(){
                this.office_options = _.filter(this.offices, ['is_quota_office', 0]);
                if (this.office_options.length == 0 ){
                    this.office_options = _.filter(this.offices, ['is_quota_office', 1]);
                }
                this.office_options = _.sortBy(this.office_options, ['code', 'load_order']);
            },
            goBack() {
                window.location = '/settings/teams/' + this.currentTeamId;
            },

            sort: function(sortBy){
                if(this.sortBy === sortBy) {
                    this.sortOrder = -this.sortOrder;
                } else {
                    this.sortBy = sortBy
                }
            },

            getMonthName(monthName) {

                let date = new Date(monthName+"/01/"+this.currentYear);
                return date.toLocaleString('en-us', { month: 'short' });
            },

            addContractQuotaDiv() {
                if (this.form.office_id && this.form.office_percentage) {
                    let contractType = {
                        office_id: this.form.office_id,
                        contract_type_id: null,
                        percentage: null,
                        contract_type_name: null,
                        proposal_volume: null,
                        proposal_count: null,
                        proposal_gross_margin: null,
                        contract_volume: null,
                        contract_count: null,
                        contract_gross_margin: null,
                        sales_behavior_hours: null,
                        contract_type_id_error: null,
                        contract_type_percentage_error: null,
                    }
                    this.selected_contract_types.push(contractType)
                } else {
                    if (!this.form.office_id) {
                        this.customErrors.office_id = 'Office is required'
                    }
                    if (!this.form.office_percentage) {
                        this.customErrors.office_quota_percentage = 'Valid Office quota percentage is required'
                    }
                }

            },
            deleteContractTypeQuota(item, index) {
                if (index > -1) {
                    this.selected_contract_types.splice(index, 1) && this.selected_contract_types;
                }
            },
            checkContractType(event, item, index) {
                let itemValue = parseInt(event.target.value);
                let arrayContractType = this.selected_contract_types.filter((value, key) =>
                    value.contract_type_id === itemValue && key !== index
                );
                if (arrayContractType.length !== 0) {
                    item.contract_type_id_error = "This contract type is already selected please select another contract type.";
                    return null;
                } else {
                    item.contract_type_id_error = null;
                    return itemValue;
                }
            },
            checkOffice(event) {
                let itemValue = parseInt(event.target.value);
                let arrayOffice = this.form.office_quotas.filter((value, key) =>
                    value.office_id === itemValue
                );
                let allOfficeOption = _.find(this.office_options, ['is_all_offices', 1]);
                let alreadyAddedAllOffices = this.form.office_quotas.filter((value, key) =>
                    value.office_id === allOfficeOption.id
                );
                if (alreadyAddedAllOffices.length !== 0){
                    if (this.form.office_quotas.length !== 0){
                        this.customErrors.office_id = "You have selected the “All Offices” filter. In order to select the specific office please delete the All Offices quota.";
                        return null;
                    }
                }


                if (allOfficeOption && itemValue === allOfficeOption.id){
                    if (this.form.office_quotas.length !== 0){
                        this.customErrors.office_id = "Please remove the added office first.";
                        this.form.office_id = null;
                        return null;
                    }
                    this.form.office_percentage = 100;
                    this.office_selected_percentage = true;
                }else {
                    this.form.office_percentage = '';
                    this.office_selected_percentage = false;
                }

                if (arrayOffice.length !== 0) {
                    this.customErrors.office_id = "This office is already selected please select another office.";
                    return null;
                } else {
                    this.customErrors.office_id = null;
                    return itemValue;
                }
            },

            calculateContractTypePercentage(event, itemValue, index) {
                if (parseInt(event.target.value) > 100){
                    return 'Contract type quota percentage should be less than or equal to 100';
                }
                let arrayContractTypes = this.selected_contract_types.filter((item, key) =>
                    key !== index
                );
                let sum = arrayContractTypes.reduce((n, {percentage}) => parseInt(n) + parseInt(percentage), 0);

                if (sum > 0) {
                    let contactTypePercentageError = parseInt(sum) + parseInt(event.target.value)
                    if (contactTypePercentageError > 100) {
                        return 'Contract type quota percentage should be less than or equal to ' + (100 - parseInt(sum));
                    } else {
                        return null;
                    }
                } else {
                    return null;
                }
            },

            calculateOfficePercentage(event) {
                if (parseInt(event.target.value) > 100){
                    return 'Office quota percentage should be less than or equal to 100';
                }
                let sum = this.form.office_quotas.reduce((n, {percentage}) => parseInt(n) + parseInt(percentage), 0);

                if (sum > 0) {
                    let officePercentageError = parseInt(sum) + parseInt(event.target.value)
                    if (officePercentageError > 100) {
                        return 'Office quota percentage should be less than or equal to ' + (100 - parseInt(sum));
                    } else {
                        return null;
                    }
                } else {
                    return null;
                }
            },

            saved() {
                this.updateOfficeQuotas()
                // this.updateContractTypeQuotas()
                let self = this;
                self.form.currentSelectedYear = this.currentYear;
                if(self.selectedMember.length == 0) {

                    self.selectedMember.push(self.currentMember.id);
                }

                const payload = {
                    member: JSON.stringify(self.selectedMember),
                    remainderStatus: JSON.stringify(self.remainderStatus),
                    teamId: this.actionTeamId
                };

                self.form.post(route('api.settings.team.member.quota.store.bulk', payload)).then((res) => {
                    this.issave = true;
                    this.user_tab = true;
                    this.office_tab = false;
                    $("#quotaModal").modal("hide");
                    window.location.reload();
                }).catch(error => {
                    this.issave = true;
                    this.user_tab = true;
                    this.office_tab = false;
                });
            },

            getQuotaData() {
                $('.proposal-overlay').show();
                axios.post(route('api.settings.team.member.quota.get.bulk'), {year: this.currentYear, teamId: this.actionTeamId}).then((data) => {
                    this.allMember = data.data.allMember;
                    this.officeQuotaList = data.data.officeQuotaData;
                    this.contractTypeQuotaList = data.data.contractTypeQuotaData;
                    this.allMemberOverall = data.data.allMemberOverall;
                    this.allOfficeOverall = data.data.allOfficeOverall;
                    this.allContractTypeOverall = data.data.allContractTypeOverall;
                    $('.proposal-overlay').hide();
                });
            },

            editQuota(member, month) {
                this.form.reset();
                this.user_tab = true;
                this.office_tab = false;
                $("#quotaModal").modal("show");

                this.currentMember = member;

                this.editing = true;

                if(month < 10) {
                    month = '0'+month;
                }

                Object.assign(this.form, {
                    date: this.currentYear+'-'+month+'-01',
                });
                this.current_quota = member.quotas.filter(quota => {
                    return quota.formatted_date == this.currentYear+'-'+month;
                });

                if(this.current_quota.length > 0) {

                    this.current_quota = this.current_quota[0];

                    Object.assign(this.form, {
                        proposal_volume: this.current_quota.proposal_volume ? Number(this.current_quota.proposal_volume.split(',').join('')) : null,
                        contract_volume: this.current_quota.contract_volume ? Number(this.current_quota.contract_volume.split(',').join('')) : null,
                        proposal_gross_margin: this.current_quota.proposal_gross_margin ? Number(this.current_quota.proposal_gross_margin.split(',').join('')) : null,
                        contract_gross_margin: this.current_quota.contract_gross_margin ? Number(this.current_quota.contract_gross_margin.split(',').join('')) : null,
                        proposal_count: this.current_quota.proposal_count,
                        contract_count: this.current_quota.contract_count,
                        sales_behavior_hours: this.current_quota.sales_behavior_hours,
                        office_quotas: this.current_quota.office_quotas,
                        contract_type_quotas: this.current_quota.contract_type_quotas,
                        currentSelectedYear:this.currentYear,
                    });
                }
                else {

                    this.current_quota = null;
                }
            },

            addOfficeQuota() {
                let self = this;
                if (self.form.office_id && self.form.office_percentage) {
                    if (self.form.office_percentage > 100) {
                        self.customErrors.office_quota_percentage = 'Office quota percentage should be less than or equal to 100'
                    } else {
                        self.office_selected_percentage = false;
                        if (!self.form.office_quotas.find(x => x.office_id == self.form.office_id)) {
                            self.form.office_quotas.push({
                                office_id: self.form.office_id,
                                office_name: self.offices.find(x => x.id == self.form.office_id).code,
                                percentage: self.form.office_percentage,
                                proposal_volume: ((self.form.proposal_volume * self.form.office_percentage) / 100).toFixed(2),
                                proposal_count: ((self.form.proposal_count * self.form.office_percentage) / 100).toFixed(2),
                                proposal_gross_margin: ((self.form.proposal_gross_margin * self.form.office_percentage) / 100).toFixed(2),
                                contract_volume: ((self.form.contract_volume * self.form.office_percentage) / 100).toFixed(2),
                                contract_count: ((self.form.contract_count * self.form.office_percentage) / 100).toFixed(2),
                                contract_gross_margin: ((self.form.contract_gross_margin * self.form.office_percentage) / 100).toFixed(2),
                                sales_behavior_hours: ((self.form.sales_behavior_hours * self.form.office_percentage) / 100).toFixed(2),
                                office_contract_type_quotas: self.selected_contract_types,
                            })

                            self.form.office_quotas.map(quota => {
                                return Object.assign(quota, {
                                    'office_contract_type_quotas': self.updateContractTypeQuotas(quota.office_contract_type_quotas, quota),
                                })
                            })
                            self.form.office_id = null
                            self.form.office_percentage = null
                            self.contract_type_percentage_value = 0;
                            self.selected_contract_types = [];
                        } else {
                            self.customErrors.office_id = 'Select some other office'
                        }
                    }
                } else {
                    if (!self.form.office_id) {
                        self.customErrors.office_id = 'Office is required'
                    }
                    if (!self.form.office_percentage) {
                        self.customErrors.office_quota_percentage = 'Valid Office quota percentage is required'
                    }
                }
            },
            setBidVolume(proposal_volume, selectedType) {
                return selectedType.proposal_volume + '(' + selectedType.percentage + '%)'
            },
            setContractVolume(contract_volume, selectedType) {
                return selectedType.contract_volume + '(' + selectedType.percentage + '%)';
            },

            removeOfficeQuota(officeId){
                this.office_selected_percentage = false;
                this.form.office_quotas = this.form.office_quotas.filter(function( obj ) {
                    return obj.office_id !== officeId;
                });
            },

            // addContractQuota(){
            //     if(this.form.contract_type_id && this.form.contract_type_percentage){
            //
            //         if(this.form.contract_type_percentage > 100) {
            //             this.customErrors.contract_type_percentage = 'Contract type quota percentage should be less than or equal to 100'
            //         }else {
            //             if (!this.form.contract_type_quotas.find(x => x.contract_type_id == this.form.contract_type_id)) {
            //                 this.form.contract_type_quotas.push({
            //                     contract_type_id: this.form.contract_type_id,
            //                     contract_type_name: this.contractTypes.find(x => x.id == this.form.contract_type_id).code,
            //                     percentage: this.form.contract_type_percentage,
            //                     proposal_volume: (this.form.proposal_volume * this.form.contract_type_percentage) / 100,
            //                     proposal_count: (this.form.proposal_volume * this.form.contract_type_percentage) / 100,
            //                     proposal_gross_margin: (this.form.proposal_gross_margin * this.form.contract_type_percentage) / 100,
            //                     contract_volume: (this.form.contract_volume * this.form.contract_type_percentage) / 100,
            //                     contract_count: (this.form.contract_volume * this.form.contract_type_percentage) / 100,
            //                     contract_gross_margin: (this.form.contract_gross_margin * this.form.contract_type_percentage) / 100,
            //                     sales_behavior_hours: (this.form.sales_behavior_hours * this.form.contract_type_percentage) / 100,
            //                 })
            //
            //                 this.form.contract_type_id = null
            //                 this.form.contract_type_percentage = null
            //             }else{
            //                 this.customErrors.contract_type_id = 'Select some other contract type'
            //             }
            //         }
            //     }else{
            //         if(!this.form.contract_type_id){
            //             this.customErrors.contract_type_id = 'Contract type is required'
            //         }
            //         if(!this.form.contract_type_percentage){
            //             this.customErrors.contract_type_percentage = 'Valid Contract type quota percentage is required'
            //         }
            //     }
            // },

            // removeContractQuota(contractTypeId){
            //     this.form.contract_type_quotas = this.form.contract_type_quotas.filter(function( obj ) {
            //         return obj.contract_type_id !== contractTypeId;
            //     });
            // },

            updateOfficeQuotas() {
                this.form.office_quotas = this.form.office_quotas.map(quota => {
                    return {
                        office_id: quota.office_id,
                        office_name: this.offices.find(x => x.id === quota.office_id).code,
                        percentage: quota.percentage,
                        proposal_volume: ((this.form.proposal_volume * quota.percentage) / 100).toFixed(2),
                        proposal_count: ((this.form.proposal_count * quota.percentage) / 100).toFixed(2),
                        proposal_gross_margin: ((this.form.proposal_gross_margin * quota.percentage) / 100).toFixed(2),
                        contract_volume: ((this.form.contract_volume * quota.percentage) / 100).toFixed(2),
                        contract_count: ((this.form.contract_count * quota.percentage) / 100).toFixed(2),
                        contract_gross_margin: ((this.form.contract_gross_margin * quota.percentage) / 100).toFixed(2),
                        sales_behavior_hours: ((this.form.sales_behavior_hours * quota.percentage) / 100).toFixed(2),
                        office_contract_type_quotas: quota.office_contract_type_quotas,
                    }
                })

                this.form.office_quotas.map(quota => {
                    return Object.assign(quota, {
                        'office_contract_type_quotas': this.updateContractTypeQuotas(quota.office_contract_type_quotas, quota),
                    })
                })
            },

            updateContractTypeQuotas(contractTypeQuotas, quotaOffice) {
                return contractTypeQuotas.map(quota => {
                    return {
                        office_id: quota.office_id,
                        contract_type_id: quota.contract_type_id,
                        contract_type_name: this.contractTypes.find(x => x.id === quota.contract_type_id).code,
                        percentage: quota.percentage,
                        proposal_volume: ((quotaOffice.proposal_volume * quota.percentage) / 100).toFixed(2),
                        proposal_count: ((quotaOffice.proposal_count * quota.percentage) / 100).toFixed(2),
                        proposal_gross_margin: ((quotaOffice.proposal_gross_margin * quota.percentage) / 100).toFixed(2),
                        contract_volume: ((quotaOffice.contract_volume * quota.percentage) / 100).toFixed(2),
                        contract_count: ((quotaOffice.contract_count * quota.percentage) / 100).toFixed(2),
                        contract_gross_margin: ((quotaOffice.contract_gross_margin * quota.percentage) / 100).toFixed(2),
                        sales_behavior_hours: ((quotaOffice.sales_behavior_hours * quota.percentage) / 100).toFixed(2),
                    }
                })
            }

        }
    }
</script>

<style scoped>
.table thead th {
    vertical-align: baseline;
}
.scrollbar {

    overflow-x:scroll;
    overflow-y: hidden;
    scrollbar-width: thin;
}
.scrollbar::-webkit-scrollbar-track {

    box-shadow: #fafafa;
}
.scrollbar::-webkit-scrollbar {

    width: 7px;
    height: 7px;
}
.scrollbar::-webkit-scrollbar-thumb {

    border-radius: 10px;
    background-color: #c1c1c1;
}

.proposal-overlay{
    position: fixed;
    display: none;
    width: 100%;
    height: 100%;
    top:18px;
    left: 0;
    right: 0;
    bottom: 0;
//background-color: rgba(0,0,0,0.5);
    z-index: 999;
    cursor: pointer;
    background: #ffffffd9;
}
.proposal-overlay img{
    position: absolute;
    right: 42%;
    top: 28%;
}
</style>

<style>
.datePickerCalendarCss {
    width: 100% !important;
}
</style>
